import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Right section of the layout containing various components
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [
                PlayersView, // Players view component
                RecordWithdrawalRequest, // Record withdrawal request component
                DetailsWithdrawalRequest, // Details withdrawal request component
            ],
        };

        // Toolbar configuration with pagination and selection
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    options: ['10', '20', '50', '100'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size based on selection
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA', // ID for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left section of the layout containing filter and table components
        const left = {
            rows: [
                FilterWithdrawalRequests, // Filter component for withdrawal requests
                TableWithdrawalRequest, // Table component for withdrawal requests
                toolbar, // Toolbar component
            ],
        };

        // Advanced details section in an accordion
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Header and body for advanced details
        };

        // Responsive advanced details section
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            id: 'carousel1', // ID for the responsive accordion
            rows: [
                {
                    id: 'dColl', // ID for the details collection
                    header: _('Detalles Avanzados'), // Header for advanced details
                    body: right, // Body containing right section
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            var height; // Variable to store height
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Recalculate height if collapsed
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        // Main layout configuration
        return {
            id: 'a5', // ID for the main view
            type: 'clean',
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling', // CSS class for styling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [
                        left, // Left section
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Conditional rendering based on screen width
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up necessary functionalities.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            $.fn.scrollBottom = function () {
                return $(document).height() - this.scrollTop() - this.height(); // Function to calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
